import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "short": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "sentence that shows up on checklist"
    },
    "codes": {
      "workflows": ["voip", "dso"],
      "description": "these will be hard-coded in the UI"
    },
    "corresponding": {
      "workflows": ["non-voip", "dso"],
      "description": "they are just there to serve as a reference"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const registrationCompleteSlice = createSlice({
  name: 'registrationComplete',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = registrationCompleteSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.registrationComplete.baseUrl;
export const selectStageCheckList = (state) => state.registrationComplete.stageCheckList;
export const selectLoading = (state) => state.registrationComplete.loading;
export const selectError = (state) => state.registrationComplete.error;
export const selectSuccess = (state) => state.registrationComplete.success;

export default registrationCompleteSlice.reducer;
